module.exports = __webpack_public_path__ + "static/img/tapapp_logo.d7f3e6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tapapp_logo.png
// module id = 6JPQ
// module chunks = 1